// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a46fe125","84":"c5702170","395":"5fba82dc","453":"7b535a73","571":"84295d70"}[chunkId] + ".chunk.js";
};